import { render, staticRenderFns } from "./tags_input.vue?vue&type=template&id=1e834d2f&"
import script from "./tags_input.vue?vue&type=script&lang=js&"
export * from "./tags_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports